import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Layout from './components/Layout';
import PayoutsReports from './payouts/payoutsReport';
import { resetReports } from './actions';
import Filters from './filters/FiltersContainer';
import ExportableReport from './ExportableReport';
import DownloadHourlyWageReportButton from './hourlyWageReport/DownloadHourlyWageReportButton';
import DownloadAdpReportButton from './hourlyWageReport/DownloadAdpReportButton';
import DownloadPaylocityReportButton from './hourlyWageReport/DownloadPaylocityReportButton';

class PayoutsReport extends Component {
  componentWillUnmount() {
    this.props.resetReports();
  }

  render() {
    return (
      <Layout title="Payouts">
        <div className="layout">
          <div className="layout__item u-3/6">
            <Filters
              csv={this.props.downloadCsv}
              disableBarberFilter
              showCsvExport={this.props.canLoadReport}
            />
          </div>
          <div className="layout__item u-3/6 u-text-right">
            <DownloadPaylocityReportButton />
            <DownloadAdpReportButton />
            <DownloadHourlyWageReportButton />
          </div>
        </div>
        <ExportableReport
          canLoadReport={this.props.canLoadReport}
          name="payout-report"
          label="Payout"
          exportReportDays={this.props.exportReportDays}
        >
          <PayoutsReports />
        </ExportableReport>
      </Layout>
    );
  }
}

const mapStateToProps = state => ({
  shop: state.auth.shop,
});

const mapDispatchToProps = {
  resetReports,
};

PayoutsReport.propTypes = {
  resetReports: PropTypes.func.isRequired,
  canLoadReport: PropTypes.bool.isRequired,
  downloadCsv: PropTypes.func.isRequired,
  exportReportDays: PropTypes.number.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PayoutsReport);
